import * as React from 'react';
import { Column, DataTableData } from '../DataTable';
import { Cell } from './Cell';

export interface RowProps<T extends DataTableData> {
    /**
     * The item being displayed on this row
     */
    item: T;
    /**
     * The columns being displayed
     */
    columns: Column[];
    /**
     * Classes to assign to the <tr> element
     */
    className: string;
    /**
     * Function to handle an input changing
     */
    onInputChange?: (column: Column, value: string) => void;
}

/**
 * The Table Row component
 * @param props Component props
 */
export function Row<T extends DataTableData>(props: RowProps<T>) {
    return (
        <tr className={props.className}>
            {props.columns.map(column => (
                <Cell
                    column={column}
                    item={props.item}
                    className={props.className}
                    key={props.item.key + '_' + column.key}
                    onInputChange={value => {
                        if (props.onInputChange) {
                            props.onInputChange(column, value);
                        }
                    }}
                />
            ))}
        </tr>
    );
}
